import React, { Component } from "react";
import { connect } from "react-redux";
import { ResponsiveBar } from "@nivo/bar";
import {
  refreshUsersAgents,
  addChatSimult,
  addChat,
  typingadd,
  ShowVisibleNextAtd,
} from "../actions";
import _ from "lodash";
import TimeCounterInternal from "./TimeCounterInternal";
import Moment from "moment";
import BarChart from "../components/manager-section/BarChart/BarChart";
import UserPhoto from "../components/UserPhoto/userphoto";

import "../build/css/manager-perfomance.css";

import { ReactComponent as IconClose } from "../build/images/closecircle22px.svg";
import { ReactComponent as Arrow } from "../build/images/arrow-left.svg";
import { ReactComponent as ArrowDown } from "../build/images/arrow_down.svg";
import { ReactComponent as Search } from "../build/images/teams/search-normal.svg";
import { ReactComponent as UserSearch } from "../build/images/teams/user-search.svg";
import { ReactComponent as Entrada } from "../build/images/teams/managerPerfomance/login.svg";
import { ReactComponent as Saida } from "../build/images/teams/managerPerfomance/logout.svg";
import { ReactComponent as Agente } from "../build/images/teams/managerPerfomance/user-square.svg";
import CLIENTE from "../build/images/user.svg";
import BarChartV2 from "../components/manager-section/BarChartV2/BarChartV2";

var TimeFormat = require("hh-mm-ss");

var sortAtual =
  localStorage.getItem("managerperfomance_filter_sortname") || "duration";
var sort = localStorage.getItem("managerperfomance_filter_ordersort") || "desc";
var checkFiltro = false;
var chars = "";
var titulo =
  localStorage.getItem("managerperfomance_filter_order") || "duração do status";

const mapDispatchToProps = (dispatch) => {
  return {
    testeeditar: (post, nome) => {
      dispatch(refreshUsersAgents(post, nome));
    },
    InitialChat: (iduser, displayname, view) => {
      let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
      dispatch(addChatSimult(iduser, displayname, view, view.ramal, datatime));
      dispatch(
        addChat(iduser, displayname, false, false, view.ramal, datatime)
      );
      dispatch(typingadd(iduser, displayname));
    },
    ShowVisibleNextAtdIn: (post, temp) => {
      dispatch(ShowVisibleNextAtd(post, temp));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    listCallQueue: state.listcallqueue,
    UserGroups: state.groups,
    usersatd: state.agents,
    ChatSimult: state.chatsimult,
    Messages: state.messages,
    InfoUsers: state.informationusers,
    gruposatd: state.groups,
    IPCurrent: state.ipcurrent,
    DisplayNextAtd: state.displaynextatd,
  };
};

class ManagerPerfomance extends Component {
  constructor(props) {
    var storageGroup =
      localStorage.getItem("managerperfomance_filter_group") || [];
    if (storageGroup.length !== 0) {
      storageGroup = storageGroup.split(",").map(Number);
    }
    var storageFilterOrder =
      localStorage.getItem("managerperfomance_filter_order") ||
      "duração do status";
    var storageFilterSelec =
      localStorage.getItem("managerperfomance_filter_selec") || "Dur. Status";
    var storageFilterSortname =
      localStorage.getItem("managerperfomance_filter_sortname") || "duration";
    var storageFilterSortordername =
      localStorage.getItem("managerperfomance_filter_sortordername") || "dec";
    var storageFilterSortId =
      localStorage.getItem("managerperfomance_filter_sortid") || "";
    super(props);
    this.state = {
      nameCli: "Cliente",
      buttonFilterGroup: false,
      filterGroup: storageGroup,
      titlesort: storageFilterOrder,
      filterUser: [],
      keyQueue: [],
      auxkeyQueue: [],
      buttonFilterOrd: false,
      filterOrd: "",
      sortName: storageFilterSortname,
      sortSelec: storageFilterSelec,
      idSort: storageFilterSortId,
      ordemSort: storageFilterSortordername,
      indcuser: [],
      buttonShowMajor: false,
      buttonShowMinor: false,
      visible: false,
    };
  }

  DisplayFilterGroup(e) {
    this.setState({ buttonFilterGroup: !this.state.buttonFilterGroup });
  }

  DisplayFilterOrd(e) {
    this.setState({ buttonFilterOrd: !this.state.buttonFilterOrd });
  }

  displayMajorOrMinor(type) {
    if (type === "major") {
      this.setState({ buttonShowMajor: !this.state.buttonShowMajor });
    } else {
      this.setState({ buttonShowMinor: !this.state.buttonShowMinor });
    }
  }

  getFilterGroup(e, idgroup) {
    let filtersgroupstorage = [];
    if (e.target.checked) {
      this.setState({
        filterGroup: this.state.filterGroup.concat([idgroup]),
      });
      filtersgroupstorage = this.state.filterGroup.concat([idgroup]);
    } else {
      this.setState({
        filterGroup: this.state.filterGroup.filter(function (val) {
          return val != idgroup;
        }),
      });
      filtersgroupstorage = this.state.filterGroup.filter(function (val) {
        return val != idgroup;
      });
    }
    localStorage.setItem("managerperfomance_filter_group", filtersgroupstorage);
  }

  getFilterOrd(e, idgroup) {
    if (e.target.checked) {
      this.setState({
        filterOrd: this.state.filterOrd.concat([idgroup]),
      });
    } else {
      this.setState({
        filterOrd: this.state.filterOrd.filter(function (val) {
          return val != idgroup;
        }),
      });
    }
  }

  changeUsers(e) {
    this.setState({ filterUser: e.target.value });

    if (e.target.value != "") {
      this.setState({ keyQueue: [] });
    }
    if (e.target.value === "") {
      this.setState({ keyQueue: this.state.auxkeyQueue });
    }
  }

  sortByName(event, sortName, descsort, titlesort, idsort) {
    if (descsort != null) {
      this.setState({ sortSelec: descsort, idSort: idsort });
      this.setState({ buttonFilterOrd: !this.state.buttonFilterOrd });
      localStorage.setItem("managerperfomance_filter_selec", descsort);
      localStorage.setItem("managerperfomance_filter_sortid", idsort);
    }
    if (sortName != "" && sortName != null) {
      sortAtual = sortName;
      localStorage.setItem("managerperfomance_filter_sortname", sortName);
    }
    if (titlesort != null) {
      titulo = titlesort;
      localStorage.setItem("managerperfomance_filter_order", titlesort);
    }
    this.setState({ sortName: sortAtual, titlesort: titulo });
    localStorage.setItem("managerperfomance_filter_sortname", sortAtual);
    localStorage.setItem("managerperfomance_filter_order", titulo);
  }

  sortOrder() {
    var By = this.state.ordemSort;
    if (By === "cres") {
      sort = "desc";
      localStorage.setItem("managerperfomance_filter_ordersort", sort);
      this.setState({ ordemSort: "dec" });
      localStorage.setItem("managerperfomance_filter_sortordername", "dec");
    } else {
      sort = "asc";
      localStorage.setItem("managerperfomance_filter_ordersort", sort);
      this.setState({ ordemSort: "cres" });
      localStorage.setItem("managerperfomance_filter_sortordername", "cres");
    }
  }

  ShowVisible() {
    this.props.ShowVisibleNextAtdIn(false, false);
    this.setState({ visible: true });
  }

  render() {
    const { usersatd, gruposatd, IPCurrent, DisplayNextAtd } = this.props;

    var menorAtual = 0;
    var maiorAtual = 0;
    var arrayAgent = [];
    var TempoTotalPausa = 0;
    var TempoTotalEntrada = 0;
    var TempoTotalSaida = 0;
    var TempoTotalLogado = 0;
    var gdaTotal = 0;
    var resultadoTTEntrada = 0;
    var qtdEntrada = 0;
    var psdtma = 0;
    var intma = 0;
    var outtma = 0;
    var arrayFiltro = [];

    var maiorpsdtma = 0;
    var maiorintma = 0;
    var maiorouttma = 0;
    var maiorUsu = 0;
    var maiorIdUsu = 0;
    var maiordst = 0;
    var maiorGda = 0;
    var maiorQPsd = 0;
    var maiorTmPsd = 0;
    var maiorQEnt = 0;
    var maiorQAtdEnt = 0;
    var maiorTmaEnt = 0;
    var maiorQSaida = 0;
    var maiorQAtdSaida = 0;
    var maiorTmaSaida = 0;
    var maiorRamal = 0;
    var checkMaior = false;
    var maiorstatussip = null;
    var valorduracao = 0;

    var menorpsdtma = 0;
    var menorintma = 0;
    var menorouttma = 0;
    var menorUsu = 0;
    var menorIdUsu = 0;
    var menordst = 0;
    var menorGda = 0;
    var menorQPsd = 0;
    var menorTmPsd = 0;
    var menorQEnt = 0;
    var menorQAtdEnt = 0;
    var menorTmaEnt = 0;
    var menorQSaida = 0;
    var menorQAtdSaida = 0;
    var menorTmaSaida = 0;
    var menorRamal = 0;
    var checkMenor = false;
    var startMenor = false;
    var menorstatussip = null;
    let datatimeComp = 0;
    let arrayComp = 0;
    let dataStatus = 0;
    let comparation = 0;
    let dataStatusComp = 0;
    let maiorAtualComp = 0;
    let contAgent = 0;

    if (usersatd.length != 0) {
      this.state.lsusersatd = usersatd;
      this.state.indcuser = usersatd;

      if (this.state.filterGroup != "") {
        this.state.lsusersatd = this.state.lsusersatd.filter((agent) =>
          this.state.filterGroup.includes(parseInt(agent.id_grupo))
        );
        this.state.indcuser = this.state.indcuser.filter((agent) =>
          this.state.filterGroup.includes(parseInt(agent.id_grupo))
        );
      }
    } else {
      this.state.lsusersatd = [];
    }

    if (gruposatd.length != 0) {
      this.state.lsgruposatd = gruposatd.groups;
    } else {
      this.state.lsgruposatd = [];
    }
    const list = this.state.lsusersatd || [];

    this.state.lsusersatd = _.filter(list, (agent) => {
      let arrayUsers = [
        agent.username,
        agent.ramal,
        agent.desc_grupo,
        agent.label,
      ];
      return !_.isEmpty(this.state.filterUser)
        ? arrayUsers
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterUser.toString().toLowerCase()) > -1
        : true;
    });

    if (DisplayNextAtd.displaynextatd === true && this.state.visible) {
      this.setState({ visible: false });
    }

    return (
      <>
        {this.state.visible ? (
          <div className="column-model--overflow block w-40 atendente-gestor manager-perfomance">
            <div className="content-result">
              <div className="column-model__header">
                <div className="column-model__header__title">
                  <div className="text">Desempenho de Atendimento</div>
                  <div className="icon-v2">
                    <IconClose
                      onClick={() => this.setState({ visible: false })}
                    />
                  </div>
                </div>

                <div className="column-model__header__select-row">
                  <div
                    className={
                      this.state.buttonFilterGroup ? "select active" : "select"
                    }
                  >
                    <button
                      className="select__btn"
                      type="button"
                      data-pausa="Atendimento Presencial Cliente"
                      onClick={(event) => this.DisplayFilterGroup(event)}
                    >
                      Grupos
                      <ArrowDown className="select__icon" />
                      {/* <i className="select__icon material-icons">
                        keyboard_arrow_right
                      </i> */}
                    </button>
                    <div className="options ">
                      <ul>
                        {this.state.lsgruposatd.map((group) =>
                          (() => {
                            arrayFiltro.push(group.id);

                            return (
                              <li key={group.id}>
                                <input
                                  type="checkbox"
                                  name={"inputsrvgroup" + group.id}
                                  id={"inputsrvgroup" + group.id}
                                  defaultChecked={
                                    this.state.filterGroup.findIndex(function (
                                      val
                                    ) {
                                      return val === group.id;
                                    }) !== -1
                                      ? true
                                      : false
                                  }
                                  onChange={(event) =>
                                    this.getFilterGroup(event, group.id)
                                  }
                                />
                                <label htmlFor={"inputsrvgroup" + group.id}>
                                  {group.name}
                                </label>
                              </li>
                            );
                          })()
                        )}
                      </ul>
                    </div>
                  </div>
                  {/* {    (() => { 
                                          if(checkFiltro==false){
                                              this.state.filterGroup = arrayFiltro;
                                              checkFiltro=true;
                                          }
                                        }
                                   )()
                              } */}

                  <div className="column-model__header__select-row--sort">
                    <div
                      className={
                        this.state.buttonFilterOrd ? "select active" : "select"
                      }
                    >
                      <button
                        className="select__btn"
                        type="button"
                        data-pausa="Ordenar por"
                        onClick={(event) => this.DisplayFilterOrd(event)}
                      >
                        <div className="select__btn__name">
                          {this.state.sortSelec}
                        </div>
                        <ArrowDown className="select__icon" />
                        {/* <i className="select__icon material-icons">
                          keyboard_arrow_right
                        </i> */}
                      </button>
                      <div className="options ">
                        <ul>
                          <li
                            key={1}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "duration",
                                "Dur. Status",
                                "duração do status",
                                1
                              )
                            }
                          >
                            <label htmlFor="filter1">Dur. Status</label>
                          </li>
                          <li
                            key={2}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "gdaagent",
                                "GDA",
                                "GDA",
                                2
                              )
                            }
                          >
                            <label htmlFor="filter2">GDA</label>
                          </li>
                          <li
                            key={3}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "psdcount",
                                "Qtde. Pausas",
                                "quantidade de pausas",
                                3
                              )
                            }
                          >
                            <label htmlFor="filter3">Qtde. Pausas</label>
                          </li>
                          <li
                            key={4}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "tmpausa",
                                "TM Pausas",
                                "tempo médio de pausas",
                                4
                              )
                            }
                          >
                            <label htmlFor="filter4">TM Pausas</label>
                          </li>
                          <li
                            key={5}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "incallcount",
                                "Qtde. Entrada",
                                "quantidade de chamadas de entrada",
                                5
                              )
                            }
                          >
                            <label htmlFor="filter5">Qtde. Entrada</label>
                          </li>
                          <li
                            key={6}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "inanscount",
                                "Qtde. Atd. Entrada",
                                "quantidade atendidas na entrada",
                                6
                              )
                            }
                          >
                            <label htmlFor="filter6">Qtde. Atd. Entrada</label>
                          </li>
                          <li
                            key={7}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "tmentrada",
                                "TMA Entrada",
                                "tempo médio de atendimento na entrada",
                                7
                              )
                            }
                          >
                            <label htmlFor="filter7">TMA Entrada</label>
                          </li>
                          <li
                            key={8}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "outcallcount",
                                "Qtde. Saída",
                                "quantidade de chamadas de saída",
                                8
                              )
                            }
                          >
                            <label htmlFor="filter8">Qtde. Saída</label>
                          </li>
                          <li
                            key={9}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "outanscount",
                                "Qtde. Atd. Saída",
                                "quantidade de atendimento na saída",
                                9
                              )
                            }
                          >
                            <label htmlFor="filter9">Qtde. Atd. Saída</label>
                          </li>
                          <li
                            key={10}
                            onClick={(event) =>
                              this.sortByName(
                                event,
                                "tmsaida",
                                "TMA Saída",
                                "tempo médio de atendimento na saída",
                                10
                              )
                            }
                          >
                            <label htmlFor="filter10">TMA Saída</label>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column-model__body">
                {this.state.lsusersatd.map((user) =>
                  (() => {
                    if (user.status_sip != "" && user.status_sip != null) {
                      if (
                        parseInt(
                          parseInt(user.psdtma) +
                            parseInt(user.intmans) +
                            parseInt(user.outtmans)
                        ) /
                          parseInt(user.tmlogin) <=
                        1
                      ) {
                        TempoTotalPausa =
                          parseInt(user.psdtma) > 0
                            ? parseInt(user.psdtma) + parseInt(TempoTotalPausa)
                            : parseInt(TempoTotalPausa);
                        TempoTotalEntrada =
                          parseInt(user.intmans) > 0
                            ? parseInt(user.intmans) +
                              parseInt(TempoTotalEntrada)
                            : parseInt(TempoTotalEntrada);
                        TempoTotalSaida =
                          parseInt(user.outtmans) > 0
                            ? parseInt(user.outtmans) +
                              parseInt(TempoTotalSaida)
                            : parseInt(TempoTotalSaida);
                        TempoTotalLogado =
                          parseInt(user.tmlogin) > 0
                            ? parseInt(user.tmlogin) +
                              parseInt(TempoTotalLogado)
                            : parseInt(TempoTotalLogado);
                        qtdEntrada =
                          parseInt(user.inanscount) > 0
                            ? parseInt(user.inanscount) + parseInt(qtdEntrada)
                            : parseInt(qtdEntrada);
                      }
                      psdtma = TimeFormat.fromS(
                        parseInt(user.tmpausa) > 0 ? parseInt(user.tmpausa) : 0,
                        "hh:mm:ss"
                      ).split(".");

                      intma = TimeFormat.fromS(
                        parseInt(user.tmentrada) > 0
                          ? parseInt(user.tmentrada)
                          : 0,
                        "hh:mm:ss"
                      ).split(".");
                      outtma = TimeFormat.fromS(
                        parseInt(user.tmsaida) > 0 ? parseInt(user.tmsaida) : 0,
                        "hh:mm:ss"
                      ).split(".");

                      let arrayCompA = user.duration.split("-");
                      let valorDiferenca = parseInt(
                        Math.abs(Math.round(IPCurrent.difftime))
                      );
                      let datatimeCompA = Moment().format(
                        "YYYY/MM/DD HH:mm:ss"
                      );
                      if (parseInt(IPCurrent.difftime) < 0) {
                        datatimeCompA = Moment()
                          .subtract(valorDiferenca, "seconds")
                          .format("YYYY/MM/DD HH:mm:ss");
                      } else {
                        datatimeCompA = Moment()
                          .add(valorDiferenca, "seconds")
                          .format("YYYY/MM/DD HH:mm:ss");
                      }

                      let dataStatusA = Moment(
                        arrayCompA[0],
                        "DD/MM/YYYY HH:mm:ss"
                      ).format("YYYY/MM/DD HH:mm:ss");
                      let duracao = Moment(datatimeCompA).diff(
                        dataStatusA,
                        "seconds"
                      );

                      arrayAgent[contAgent] = {
                        idusu: parseInt(user.value),
                        username: user.username,
                        ramal: user.ramal,
                        idgrupo: parseInt(user.id_grupo),
                        descgrupo: user.desc_grupo,
                        inanscount:
                          parseInt(user.inanscount) > 0
                            ? parseInt(user.inanscount)
                            : 0,
                        incallcount:
                          parseInt(user.incallcount) > 0
                            ? parseInt(user.incallcount)
                            : 0,
                        insla:
                          parseInt(user.insla) > 0 ? parseInt(user.insla) : 0,
                        intmans: intma[0],
                        outanscount:
                          parseInt(user.outanscount) > 0
                            ? parseInt(user.outanscount)
                            : 0,
                        outcallcount:
                          parseInt(user.outcallcount) > 0
                            ? parseInt(user.outcallcount)
                            : 0,
                        outsla:
                          parseInt(user.outsla) > 0 ? parseInt(user.outsla) : 0,
                        outtmans: outtma[0],
                        psdcount:
                          parseInt(user.psdcount) > 0
                            ? parseInt(user.psdcount)
                            : 0,
                        psdtma: psdtma[0],
                        tmlogin:
                          parseInt(user.tmlogin) > 0
                            ? parseInt(user.tmlogin)
                            : 0,
                        duration: parseInt(duracao) > 0 ? parseInt(duracao) : 0,
                        gdaagent: user.gdaagent,
                        // tmpausa: psdtma[0],
                        tmpausa: user.tmpausa,
                        // tmentrada: intma[0],
                        tmentrada: user.tmentrada,
                        // tmsaida: outtma[0],
                        tmsaida: user.tmsaida,
                        statussip: user.status_sip,
                      };

                      contAgent++;
                    }
                  })()
                )}

                {(() => {
                  gdaTotal =
                    TempoTotalLogado > 0
                      ? [
                          100 -
                            (parseInt(
                              TempoTotalPausa +
                                TempoTotalEntrada +
                                TempoTotalSaida
                            ) /
                              parseInt(TempoTotalLogado)) *
                              100,
                        ]
                      : 0;
                  gdaTotal = parseInt(gdaTotal) > 0 ? gdaTotal : 0;
                  resultadoTTEntrada = TimeFormat.fromS(
                    TempoTotalEntrada > 0
                      ? parseInt(TempoTotalEntrada) / parseInt(qtdEntrada)
                      : 0,
                    "hh:mm:ss"
                  ).split(".");
                })()}

                {/* <div className="resume">
              <div className="resume__item">
                <div
                  className="resume__item__text"
                  title="Grau de disponibilidade do operador"
                >
                  GDA:
                </div>
                <div className="resume__item__number">
                  {parseFloat(gdaTotal).toFixed(2)}%
                </div>
              </div>
              <div className="resume__item">
                <div
                  className="resume__item__text"
                  title="Quantidade de atendimentos na entrada"
                >
                  q.atd.ent:
                </div>
                <div className="resume__item__number">{qtdEntrada}</div>
              </div>
              <div className="resume__item">
                <div
                  className="resume__item__text"
                  title="Tempo médio de atendimento na entrada"
                >
                  tma e:
                </div>
                <div className="resume__item__number">
                  {resultadoTTEntrada[0]}
                </div>
              </div>
            </div> */}

                {(() => {
                  if (this.state.sortName != undefined) {
                    chars = arrayAgent;
                    chars = _.orderBy(chars, [this.state.sortName], [sort]);
                    arrayAgent = chars;
                  }
                })()}

                {this.state.indcuser.map((agent) =>
                  (() => {
                    if (agent.status_sip != "" && agent.status_sip != null) {
                      arrayComp = agent.duration.split("-");
                      datatimeComp = Moment().format("YYYY/MM/DD HH:mm:ss");
                      dataStatus = Moment(
                        arrayComp[0],
                        "DD/MM/YYYY HH:mm:ss"
                      ).format("YYYY/MM/DD HH:mm:ss");

                      let valorDiferenca = parseInt(
                        Math.abs(Math.round(IPCurrent.difftime))
                      );

                      if (parseInt(IPCurrent.difftime) < 0) {
                        datatimeComp = Moment()
                          .subtract(valorDiferenca, "seconds")
                          .format("YYYY/MM/DD HH:mm:ss");
                      } else {
                        datatimeComp = Moment()
                          .add(valorDiferenca, "seconds")
                          .format("YYYY/MM/DD HH:mm:ss");
                      }

                      if (this.state.sortName == "duration") {
                        comparation = agent[this.state.sortName].split("-");
                        //dataStatusComp   = Moment(comparation[0], 'DD/MM/YYYY HH:mm:ss').format('YYYY/MM/DD HH:mm:ss');
                        dataStatusComp = Moment(
                          comparation[0],
                          "YYYY/MM/DD HH:mm:ss"
                        );
                        maiorAtualComp = Moment(datatimeComp).diff(
                          dataStatusComp,
                          "seconds"
                        );
                      } else {
                        maiorAtualComp = agent[this.state.sortName];
                      }

                      valorduracao = Moment(datatimeComp).diff(
                        dataStatus,
                        "seconds"
                      );
                      if (parseInt(valorduracao) < 0) {
                      }

                      if (parseInt(maiorAtualComp) >= parseInt(maiorAtual)) {
                        if (this.state.sortName == "duration") {
                          maiorAtual = valorduracao;
                        } else {
                          maiorAtual = agent[this.state.sortName];
                        }

                        maiorpsdtma = TimeFormat.fromS(
                          parseInt(agent.psdtma) > 0 &&
                            parseInt(agent.psdcount) > 0
                            ? parseInt(agent.psdtma) / parseInt(agent.psdcount)
                            : 0,
                          "hh:mm:ss"
                        ).split(".");
                        maiorintma = TimeFormat.fromS(
                          parseInt(agent.intmans) > 0 &&
                            parseInt(agent.inanscount) > 0
                            ? parseInt(agent.intmans) /
                                parseInt(agent.inanscount)
                            : 0,
                          "hh:mm:ss"
                        ).split(".");
                        maiorouttma = TimeFormat.fromS(
                          parseInt(agent.outtmans) > 0 &&
                            parseInt(agent.outanscount) > 0
                            ? parseInt(agent.outtmans) /
                                parseInt(agent.outanscount)
                            : 0,
                          "hh:mm:ss"
                        ).split(".");
                        maiorUsu = agent.username;
                        maiorRamal = agent.ramal;
                        maiordst = valorduracao;
                        maiorGda =
                          parseInt(agent.tmlogin) > 0
                            ? [
                                100 -
                                  (parseInt(
                                    parseInt(agent.psdtma) +
                                      parseInt(agent.intmans) +
                                      parseInt(agent.outtmans)
                                  ) /
                                    parseInt(agent.tmlogin)) *
                                    100,
                              ]
                            : 0;
                        maiorQPsd = agent["psdcount"];
                        maiorTmPsd = maiorpsdtma[0];
                        maiorQEnt = agent.incallcount;
                        maiorQAtdEnt = agent.inanscount;
                        maiorTmaEnt = maiorintma[0];
                        maiorQSaida = agent.outcallcount;
                        maiorQAtdSaida = agent.outanscount;
                        maiorTmaSaida = maiorouttma[0];
                        maiorstatussip = agent.status_sip;
                        maiorIdUsu = agent.value;
                        checkMaior = true;
                      }

                      if (
                        parseInt(maiorAtualComp) <= parseInt(menorAtual) ||
                        startMenor == false
                      ) {
                        if (this.state.sortName == "duration") {
                          menorAtual = Moment(datatimeComp).diff(
                            dataStatus,
                            "seconds"
                          );
                        } else {
                          menorAtual = agent[this.state.sortName];
                        }

                        menorpsdtma = TimeFormat.fromS(
                          parseInt(agent.psdtma) > 0 &&
                            parseInt(agent.psdcount) > 0
                            ? parseInt(agent.psdtma) / parseInt(agent.psdcount)
                            : 0,
                          "hh:mm:ss"
                        ).split(".");
                        menorintma = TimeFormat.fromS(
                          parseInt(agent.intmans) > 0 &&
                            parseInt(agent.inanscount) > 0
                            ? parseInt(agent.intmans) /
                                parseInt(agent.inanscount)
                            : 0,
                          "hh:mm:ss"
                        ).split(".");
                        menorouttma = TimeFormat.fromS(
                          parseInt(agent.outtmans) > 0 &&
                            parseInt(agent.outanscount) > 0
                            ? parseInt(agent.outtmans) /
                                parseInt(agent.outanscount)
                            : 0,
                          "hh:mm:ss"
                        ).split(".");

                        menorUsu = agent.username;
                        menorRamal = agent.ramal;
                        menordst = valorduracao;
                        menorGda =
                          parseInt(agent.tmlogin) > 0
                            ? [
                                100 -
                                  (parseInt(
                                    parseInt(agent.psdtma) +
                                      parseInt(agent.intmans) +
                                      parseInt(agent.outtmans)
                                  ) /
                                    parseInt(agent.tmlogin)) *
                                    100,
                              ]
                            : 0;
                        menorQPsd = agent["psdcount"];
                        menorTmPsd = menorpsdtma[0];
                        menorQEnt = agent.incallcount;
                        menorQAtdEnt = agent.inanscount;
                        menorTmaEnt = menorintma[0];
                        menorQSaida = agent.outcallcount;
                        menorQAtdSaida = agent.outanscount;
                        menorTmaSaida = menorouttma[0];
                        menorstatussip = agent.status_sip;
                        menorIdUsu = agent.value;
                        checkMenor = true;
                        startMenor = true;
                      }
                    }
                  })()
                )}

                <div className="result result--major-minor">
                  <div className="result__title">
                    Maior {this.state.titlesort}
                  </div>

                  {(() => {
                    if (checkMaior == true) {
                      return (
                        <div
                          className={`result__item ${
                            this.state.buttonShowMajor ? "active-info" : ""
                          }`}
                          key={"Maior" + maiorIdUsu + maiorstatussip}
                        >
                          <div
                            className="result__item__select"
                            onClick={() => this.displayMajorOrMinor("major")}
                          >
                            {/* <div className="user-photo">
                              <img src={CLIENTE} alt="" />
                            </div> */}
                            <UserPhoto size="large" />
                            <div className="result__item__title">
                              <span className="name">{maiorUsu}</span>
                              <span className="ramal">
                                Ramal - {maiorRamal}
                              </span>
                            </div>

                            <ArrowDown className="select__icon" />
                          </div>
                          <div className={`result__item__info`}>
                            <div className="result__item__info-container">
                              <div className="result__item__info-container_title">
                                <Entrada />
                                Entrada
                              </div>
                              <div className="result__item__info-container_principal">
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de chamada de entrada"
                                  >
                                    Qtd. de chamada
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(maiorQEnt) > 0
                                      ? parseInt(maiorQEnt)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de chamadas atendidas de entrada"
                                  >
                                    Qtd. de chamadas atendidas
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(maiorQAtdEnt) > 0
                                      ? parseInt(maiorQAtdEnt)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Tempo médio de atendimento na entrada"
                                  >
                                    Tempo médio de atendimento
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {maiorTmaEnt}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="result__item__info-container">
                              <div className="result__item__info-container_title">
                                <Saida />
                                Saída
                              </div>
                              <div className="result__item__info-container_principal">
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de chamadas de saída"
                                  >
                                    Qtd. de chamadas
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(maiorQSaida) > 0
                                      ? parseInt(maiorQSaida)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de chamadas atendidas de saída"
                                  >
                                    Qtd. de chamadas atendidas
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(maiorQAtdSaida) > 0
                                      ? parseInt(maiorQAtdSaida)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Tempo médio de atendimento na saída"
                                  >
                                    Tempo médio de atendimento
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {maiorTmaSaida}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="result__item__info-container">
                              <div className="result__item__info-container_title">
                                <Agente />
                                Agente
                              </div>
                              <div className="result__item__info-container_principal">
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Duração do status"
                                  >
                                    Duração de Status
                                  </div>
                                  <div className="result__item__info__item__number">
                                    <TimeCounterInternal
                                      horario={parseInt(maiordst)}
                                    />
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Grau de ocupação do operador"
                                  >
                                    Grau de disponibilidade
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseFloat(maiorGda) > 0
                                      ? parseFloat(maiorGda).toFixed(2)
                                      : 0}
                                    %
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de pausas"
                                  >
                                    Quantidade de pausas
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(maiorQPsd) > 0
                                      ? parseInt(maiorQPsd)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Tempo médio de pausa"
                                  >
                                    Tempo médio de pausa
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {maiorTmPsd}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })()}

                  <div className="result__title">
                    Menor {this.state.titlesort}
                  </div>

                  {(() => {
                    if (checkMenor == true) {
                      return (
                        <div
                          className={`result__item ${
                            this.state.buttonShowMinor ? "active-info" : ""
                          }`}
                          key={"Menor" + menorIdUsu + menorstatussip}
                        >
                          <div
                            className="result__item__select"
                            onClick={() => this.displayMajorOrMinor("minor")}
                          >
                            {/* <div className="user-photo">
                              <img src={CLIENTE} alt="" />
                            </div> */}
                            <UserPhoto size="large" />
                            <div className="result__item__title">
                              <span className="name">{menorUsu}</span>
                              <span className="ramal">
                                Ramal - {menorRamal}
                              </span>
                            </div>

                            <ArrowDown className="select__icon" />
                          </div>
                          <div className={`result__item__info`}>
                            <div className="result__item__info-container">
                              <div className="result__item__info-container_title">
                                <Entrada />
                                Entrada
                              </div>
                              <div className="result__item__info-container_principal">
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de chamada de entrada"
                                  >
                                    Qtd. de chamada
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(menorQEnt) > 0
                                      ? parseInt(menorQEnt)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de chamadas atendidas de entrada"
                                  >
                                    {" "}
                                    Qtd. de chamadas atendidas
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(menorQAtdEnt) > 0
                                      ? parseInt(menorQAtdEnt)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Tempo médio de atendimento na entrada"
                                  >
                                    Tempo médio de atendimento
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {menorTmaEnt}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="result__item__info-container">
                              <div className="result__item__info-container_title">
                                <Saida />
                                Saída
                              </div>
                              <div className="result__item__info-container_principal">
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de chamadas de saída"
                                  >
                                    Qtd. de chamadas
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(menorQSaida) > 0
                                      ? parseInt(menorQSaida)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de chamadas atendidas de saída"
                                  >
                                    Qtd. de chamadas atendidas
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(menorQAtdSaida) > 0
                                      ? parseInt(menorQAtdSaida)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Tempo médio de atendimento na saída"
                                  >
                                    {" "}
                                    Tempo médio de atendimento
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {menorTmaSaida}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="result__item__info-container">
                              <div className="result__item__info-container_title">
                                <Agente />
                                Agente
                              </div>
                              <div className="result__item__info-container_principal">
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Duração do status"
                                  >
                                    Duração de Status
                                  </div>
                                  <div className="result__item__info__item__number">
                                    <TimeCounterInternal
                                      horario={parseInt(menordst)}
                                    />
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Grau de ocupação do operador"
                                  >
                                    Grau de disponibilidade
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseFloat(menorGda) > 0
                                      ? parseFloat(menorGda).toFixed(2)
                                      : 0}
                                    %
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Quantidade de pausas"
                                  >
                                    Quantidade de pausas
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {parseInt(menorQPsd) > 0
                                      ? parseInt(menorQPsd)
                                      : 0}
                                  </div>
                                </div>
                                <div className="result__item__info__item">
                                  <div
                                    className="result__item__info__item__text"
                                    title="Tempo médio de pausa"
                                  >
                                    Tempo médio de pausa
                                  </div>
                                  <div className="result__item__info__item__number">
                                    {menorTmPsd}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })()}
                </div>
                <hr className="hr" />
                <div className="search-result">
                  <div className="search-result--header">
                    <div className="search-result-text">
                      Indicador {this.state.sortSelec}
                    </div>
                    <div className="checkbox__with-separator checkbox checkbox__with-separator--left">
                      <div className="checkbox__row inline">
                        <div className="checkbox__row__input-icon-box">
                          <Arrow
                            className={`ordernar-arrow arrow-${this.state.ordemSort}`}
                            onClick={(event) => this.sortOrder()}
                          />
                          {/* <input
                            type="radio"
                            name="ordenamento_sort"
                            id="ordenar-cres"
                            defaultChecked
                            value="cres"
                            onClick={(event) =>
                              this.sortByName(event, null, null, null)
                            }
                          />
                          <label
                            className="checkbox__row__input-icon-box__label"
                            htmlFor="ordenar-cres"
                          >
                            <i
                              className="material-icons tippy-default"
                              data-tippy-content="Crescente"
                              tabIndex="0"
                            >
                              arrow_upward
                            </i>
                          </label> */}
                        </div>

                        {/* <div className="checkbox__row__input-icon-box">
                          <input
                            type="radio"
                            name="ordenamento_sort"
                            id="ordenar-dec"
                            value="dec"
                            onClick={(event) =>
                              this.sortByName(event, null, null, null)
                            }
                          />
                          <label
                            className="checkbox__row__input-icon-box__label"
                            htmlFor="ordenar-dec"
                          >
                            <i
                              className="material-icons tippy-default"
                              data-tippy-content="Decrescente"
                              tabIndex="0"
                            >
                              arrow_downward
                            </i>
                          </label>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="full-search">
                    <input
                      type="text"
                      name="client-search"
                      id="client-search"
                      onChange={(event) => this.changeUsers(event)}
                      placeholder="Buscar atendente"
                    />
                    <button type="button" className="full-search__btn">
                      <Search />
                      {/* <i className="material-icons">search</i> */}
                    </button>
                  </div>

                  <div className="result result--with-pd new-result-with-barchart-v2">
                    {arrayAgent.length > 0 ? (
                      <BarChartV2
                        data={arrayAgent.map((user) => {
                          let value = 0;

                          if (user.hasOwnProperty(this.state.sortName)) {
                            value = user[this.state.sortName];
                          } else {
                            return undefined;
                          }

                          return {
                            id: user.username,
                            value: parseFloat(value) > 0 ? value : 0,
                            label: user.username,
                            valueColor: "#455CC7",
                          };
                        })}
                        layout="horizontal"
                        typeValue={this.state.sortName}
                      />
                    ) : (
                      <div className="result--empty_space">
                        <div className="icon-container">
                          <UserSearch />
                        </div>
                        <span>Não encontramos nenhum atendente.</span>
                      </div>
                    )}

                    {arrayAgent.map((user) =>
                      (() => {
                        return (
                          <div
                            className="result__item"
                            key={user.idusu + user.statussip}
                          >
                            <div className="result__item__title">
                              {user.username} - {user.ramal}
                            </div>
                            <div className="result__item__info">
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Duração do status"
                                >
                                  dr.st:
                                </div>
                                <div className="result__item__info__item__number">
                                  <TimeCounterInternal
                                    horario={parseInt(user.duration)}
                                    key={user.iduser + "_" + user.status_sip}
                                  />
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Grau de disponibilidade do agente"
                                >
                                  gda:
                                </div>
                                <div className="result__item__info__item__number">
                                  {parseFloat(user.gdaagent) > 0
                                    ? parseFloat(user.gdaagent).toFixed(2)
                                    : 0}
                                  %
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Quantidade de pausas"
                                >
                                  q.psd:
                                </div>
                                <div className="result__item__info__item__number">
                                  {user.psdcount}
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Tempo médio de pausa"
                                >
                                  tm.psd:
                                </div>
                                <div className="result__item__info__item__number">
                                  {user.tmpausa}
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Quantidade de chamada de entrada"
                                >
                                  q.ent:
                                </div>
                                <div className="result__item__info__item__number">
                                  {user.incallcount}
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Quantidade de chamadas atendidas de entrada"
                                >
                                  q.atd.ent:
                                </div>
                                <div className="result__item__info__item__number">
                                  {user.inanscount}
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Tempo médio de atendimento na entrada"
                                >
                                  tma.ent:
                                </div>
                                <div className="result__item__info__item__number">
                                  {user.tmentrada}
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Quantidade de chamadas de saída"
                                >
                                  q.saída:
                                </div>
                                <div className="result__item__info__item__number">
                                  {user.outcallcount}
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Quantidade de chamadas atendidas de saída"
                                >
                                  q.atd.s:
                                </div>
                                <div className="result__item__info__item__number">
                                  {user.outanscount}
                                </div>
                              </div>
                              <div className="result__item__info__item">
                                <div
                                  className="result__item__info__item__text"
                                  title="Tempo médio de atendimento na saída"
                                >
                                  tma.s:
                                </div>
                                <div className="result__item__info__item__number">
                                  {user.tmsaida}
                                </div>
                              </div>
                            </div>
                            <hr className="hr" />
                          </div>
                        );
                        //}
                      })()
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="manager-perfomance--active"
            onClick={() => this.ShowVisible()}
          >
            <Arrow />
            <div className="text">Desempenho de Atendimento</div>
          </div>
        )}
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagerPerfomance);
